import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
const Contact = () =>{
    document.body.style.backgroundColor = "#F6F6F6"
    return (
        <div>
            <Header whihOne="contact"/>
            <section id="section_shop">
            <div className="row col-12">
                        <div className="col-sm-3" id="left_side_profile">
                        <div id="nav_profile">
                            <p id="nav_profile_title">Contact Us</p>
                            <p id="nav_profile_details">
                            Our mailing address is :
                            </p>
                            <hr  style={{color:"#CCCCCC"}}/>
                            <ul id="profile_nav_ul">
                                <li>KG 7 Avenue</li>
                                <li>Kigali - Rwanda</li>
                                <li>+250 780 486 666</li>
                            </ul>
                        </div>
                        </div>
                        <div className="col">
                            <div id="right_side_profile_div">
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Your Name</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="text" placeholder="Your Name" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                    
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 mag-A">
                                    <p id="right_side_profile_div_left_name">Email</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <input type="email" placeholder="Email" id="profile_inputs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-12" id="input_div_profile">
                                    <div className="col-3 ">
                                    <p id="right_side_profile_div_left_name">Message</p>
                                    </div>
                                    <div className="col ">
                                        <div className="row col-12 noMP">
                                            <div className="col">
                                            <textarea placeholder="Enter Your Message" id="contact_textarea" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                             
                                <div className="row col-12" id="input_div_profile">
                                <div className="col ">
                                <button id="button_save_profile">Sent</button>
                                </div>
                                </div>
                            </div>
                        </div>
            </div>            
            </section>
            <Footer />
        </div>
    )
}
export default Contact;
